<!--
参考: https://stackoverflow.com/questions/62733094/implement-a-portal-in-svelte
-->
<script lang="ts">
    import {onDestroy, onMount} from "svelte";


    export let portalTargetSelector = '#portal-target';
    export let portalClassName = '';

    let portalViewElement: HTMLElement = null;

    function getPortalTargetElement(): HTMLElement {
        const portalTargetElement: HTMLElement = document.querySelector(portalTargetSelector);
        if (portalTargetElement == null) {
            console.error('PortalTarget が見つかりません');
        }
        return portalTargetElement;
    }

    onMount(() => {
        const portalTargetElement = getPortalTargetElement();
        if (portalTargetElement != null) {
            portalTargetElement.appendChild(portalViewElement);
        }
    });
    onDestroy(() => {
        if (portalViewElement != null) {
            const portalTargetElement: HTMLElement = getPortalTargetElement();
            if (portalTargetElement != null) {
                portalTargetElement.removeChild(portalViewElement);
            }
        }
    })

</script>
<div class={`portal-view ${portalClassName}`} bind:this={portalViewElement}>
    <slot></slot>
</div>
<style lang="scss">
    .portal-view {
    }
</style>